<template>
  <div>
    <vcircle></vcircle>

    <div class="bottomFunction">
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <div v-if="cflag">
          <div class="tiaozhuan">
            <p v-for="(item, index) in clist" :key="index" @click="convey(index)">
              {{ item }}
            </p>
          </div>
        </div>
      </transition>
      <img
        v-for="(item1, index1) in bottomList"
        :key="index1 + item1"
        :src="item1.url"
        v-show="index1 < 3"
        @click="func(item1)"
      />
      <img
        v-for="(item, index) in bottomList"
        :key="index"
        :src="item.url"
        v-show="index > 2 && sitFlag"
        @click="func(item)"
      />
    </div>

    <vmap></vmap>

    <vyaoqing></vyaoqing>

    <vchat></vchat>

    <vclient></vclient>
  </div>
</template>

<script>
import vcircle from "../../bmwroom/mobilecomponent/circle.vue";
import vmap from "../../bmwroom/mobilecomponent/map.vue";
import vyaoqing from "../../bmwroom/mobilecomponent/yaoqing.vue";

import vchat from "../../bmwroom/mobilecomponent/chat.vue";

import vclient from "../../bmwroom/mobilecomponent/client.vue";
export default {
  components: {
    vcircle,
    vmap,
    vyaoqing,
    vchat,

    vclient,
  },

  methods: {
    convey(index) {
      if (this.sitFlag) {
        this.$message.error("坐下无法传送");
        return;
      }
      if (index == 2) {
        document.o2.setRolePos(0, -1118, 13874, 0, -268, 17464);
        document.o2.do_port_ani(0, -1118, 13874);
      } else if (index == 1) {
        document.o2.setRolePos(-11932, 6378, -19106, -13742, 8531, -22087);
        document.o2.do_port_ani(-11932, 6378, -19106);
      } else if (index == 0) {
        document.o2.setRolePos(-14142, 13431, -10237, -16939, 15934, -10324);
        document.o2.do_port_ani(-14142, 13431, -10237);
      }

      this.cflag = false;
    },

    func(e) {
      if (e.name == "点赞") {
        let str = "1056,gif,1";
        this.$chat.ws.send(str);
        this.value = 99;
      } else if (e.name == "鼓掌") {
        let str = "1056,gif,0";
        this.$chat.ws.send(str);
        this.value = 99;
      } else if (e.name == "起立") {
        this.Bus.$emit("stand", "");
      } else if (e.name == "视野") {
        console.log("视角");
        this.cflag = !this.cflag;
      } else if (e.name == "提问") {
        {
          let str = "1056,gif,2";
          this.$chat.ws.send(str);
        }
        let role = document.o2.role;
        if (role.bHand == undefined) role.bHand = false;
        let msg = role.bHand ? "handDown" : "handUp";
        role.bHand = !role.bHand;
        let info = { msg: msg, data: role.sit };
        let str = 1056 + "," + JSON.stringify(info);
        this.$chat.ws.send(str);
      }
    },
  },

  created() {
    this.Bus.$on("onRoleLoaded", (role) => {
      role.onStateChg.push((state) => {
        if (state == "sit") {
          this.sitFlag = true;
        } else {
          this.sitFlag = false;
        }
      });
    });
  },
  data() {
    return {
      bottomList: [
        { name: "点赞", url: require("../../bmwroom/assets/mobile/点赞.png") },
        { name: "鼓掌", url: require("../../bmwroom/assets/mobile/鼓掌.png") },
        { name: "视野", url: require("../assets/mobile/feiji.png") },
        { name: "起立", url: require("../../bmwroom/assets/mobile/站立.png") },
        // { name: "提问", url: require("../../bmwroom/assets/mobile/提问.png") },
        // { name: "视野", url: require("../assets/mobile/视野.png") },
      ],

      sitFlag: false,
      cflag: false,
      clist: ["THIRD FLOOR", "SECOND FLOOR", "FIRST FLOOR"],
    };
  },
};
</script>

<style lang="scss" scoped>
.bottomFunction {
  position: fixed;
  bottom: 37px;
  display: flex;
  left: 190px;
  img {
    width: 47px;
    height: 47px;
    margin-right: 12px;
  }
}
.tiaozhuan {
  width: 180px;
  height: 141.32px;
  opacity: 0.6;
  background: #3e5366;
  position: fixed;
  left: 240px;
  bottom: 97px;
  p {
    background: url("../assets/newImg/tiaozhuan.png");
    width: 170px;
    height: 34px;
    color: black;
    font-size: 12px;
    background-size: 100% 100%;
    line-height: 20px;
    color: white;
    cursor: pointer;
    line-height: 34px;
    margin-left: 5px;
    margin-top: 10px;
  }
}
</style>
